<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Price history
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="filters.search"
              label="Search"
              append-icon="mdi-magnify"
              clearable
              @input="debouncedFetch()"
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              v-model="filters.source_type"
              :items="sourceTypes"
              label="Source type"
              clearable
              @change="fetchData"
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              v-model="filters.change_type"
              :items="changeTypes"
              label="Change type"
              item-text="text"
              item-value="value"
              clearable
              @change="fetchData"
            />
          </v-col>

          <v-col cols="12" md="2">
            <v-btn color="primary" block @click="fetchData">
              Refresh
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :server-items-length="totalItems"
          :options.sync="options"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
            itemsPerPageOptions: [7, 10, 25, 50, 100]
          }"
          class="elevation-1"
        >
          <template v-slot:item.old_price="{ item }">
            <span>{{ formatPrice(item.old_price) }}</span>
          </template>

          <template v-slot:item.new_price="{ item }">
            <span>{{ formatPrice(item.new_price) }}</span>
          </template>

          <template v-slot:item.difference="{ item }">
            <span
              :class="{
                'error--text': item.is_increase,
                'success--text': item.is_decrease
              }"
            >
              {{ formatPrice(item.difference) }}
            </span>
          </template>

          <template v-slot:item.difference_percent="{ item }">
            <span
              :class="{
                'error--text': item.is_increase,
                'success--text': item.is_decrease
              }"
            >
              {{
                item.difference_percent !== null && item.difference_percent !== undefined
                  ? Number(item.difference_percent).toFixed(2) + '%'
                  : '-'
              }}
            </span>
          </template>

          <template v-slot:item.change_direction="{ item }">
            <v-chip
              small
              dark
              :color="
                item.is_increase
                  ? 'error'
                  : item.is_decrease
                  ? 'success'
                  : 'grey'
              "
            >
              {{
                item.is_increase
                  ? 'Increased'
                  : item.is_decrease
                  ? 'Decreased'
                  : 'No change'
              }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "ItemPriceHistoryList",
  data() {
    return {
      loading: false,
      items: [],
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 7,
      },
      filters: {
        search: "",
        source_type: null,
        change_type: null,
      },
      sourceTypes: ["adjustment", "receive", "release", "transfer"],
      changeTypes: [
        { text: "Increased", value: "increase" },
        { text: "Decreased", value: "decrease" },
      ],
      headers: [
        { text: "Date", value: "created_at" },
        { text: "Reference", value: "reference" },
        //{ text: "Item", value: "item_name" },
        { text: "Source type", value: "source_type" },
        { text: "Source ID", value: "source_id" },
        { text: "Old price", value: "old_price" },
        { text: "New price", value: "new_price" },
        { text: "Difference", value: "difference" },
        { text: "Difference %", value: "difference_percent" },
        { text: "Direction", value: "change_direction", sortable: false },
        { text: "Comment", value: "comment" },
      ],
      debounceTimer: null,
    };
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.fetchData();
      },
    },
  },

  methods: {
    debouncedFetch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.fetchData();
      }, 400);
    },

    formatPrice(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }

      return Number(value).toLocaleString("hu-HU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      }) + " Ft";
    },

    fetchData() {
      this.loading = true;

      const params = new URLSearchParams();
      params.append("page", this.options.page || 1);
      params.append("per_page", this.options.itemsPerPage || 7);

      if (this.filters.search) {
        params.append("search", this.filters.search);
      }

      if (this.filters.source_type) {
        params.append("source_type", this.filters.source_type);
      }

      if (this.filters.change_type) {
        params.append("change_type", this.filters.change_type);
      }


      ApiService.get("inventory/item-price-history", "?" + params.toString())
        .then(({ data }) => {
          this.items = data.data || [];
          this.totalItems = data.meta ? data.meta.total : 0;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>